import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Avatar, CardHeader, CircularProgress } from '@material-ui/core'
import { changeScreenB } from '../../../store/actions/navigation.action'
import { FaEyeSlash, FaDownload, FaCheck, FaUser, FaCheckCircle, FaInfo } from 'react-icons/fa'
import { IoLogoWhatsapp } from "react-icons/io"
import { show, renotificate, consult } from '../../../store/actions/transaction.action'
import { Confirm } from '../../components'

export default function Detail(props) {
    const dispatch = useDispatch()
    const id = (props.uid) ? props.uid : null;
    const user_id = (props.user_id) ? props.user_id : null;
    const { transaction, count, account } = useSelector(state => state.transactionReducer)

    const [isLoading, setLoading] = React.useState(true)
    const [ telefone, setTelefone ] = React.useState(false)
    const [confirmEl, setConfirm] = React.useState(null)
    const [status, setStatus] = React.useState('success')

    React.useEffect(() => {
        dispatch(show(id)).then(() => {
            setLoading(false)
        })
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        if(transaction.status === '1' || transaction.status === 'approved' || transaction.status === 'paid') {
            if(parseInt(transaction.payment_method_id) === count) {
                setStatus('success')
            }else {
                setStatus('renotificate')
            }
        }else {
            setStatus('not-paid')
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [transaction])

    const handlePage = (page, user_id = null) => {
        dispatch(changeScreenB({
            open: true,
            type: page,
            props: {
                user_id: user_id
            }
        }))
    }

    return (
        <>
            {isLoading ? <div className="d-flex justify-content-center p-5 bs-bg"><div className="text-center"><CircularProgress /></div></div> :
                <div className="card bs-bg">
                    <label className="card-body label-custom m-0 pb-1 bs-color-b">{transaction.rifa.title}</label>
                    <CardHeader 
                        avatar={
                            <Avatar className={status === 'success' ? "bg-success" : "bg-warning"}>
                                {status === 'success' ? <FaCheck /> : <FaInfo />}
                            </Avatar>
                        }
                        title={<h5 className="fw-bold m-0 bs-color-b">{parseInt(transaction.payment_method_id).toLocaleString('pt-BR', {style: 'decimal'})}</h5>}
                        subheader={<small className="fw-bold text-success">COTAS</small>} 
                    />

                    {(transaction.user) &&
                    <>
                        <hr className="hr-muted m-0"/>
                        
                        <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                        <CardHeader 
                            avatar={
                                <Avatar>
                                    <FaUser />
                                </Avatar>
                            }
                            title={<h6 className="fw-bold bs-color-b">{transaction.user.name ? transaction.user.name.substring(0,25) : transaction.user.name}</h6>}
                            subheader={
                                <>
                                <div className="d-flex justify-content-between">
                                    <span className="d-block pointer mb-2 bs-color" onClick={() => setTelefone(telefone ? false : true)}>{(telefone) ? transaction.user.telefone : <> {transaction.user.telefone.substring(5, -1)} ****** <FaEyeSlash /></>}</span>
                                    
                                    <span className="me-2">
                                        <a href={'http://wa.me/55'+transaction.user.telefone} target="_blank" rel="noopener noreferrer">
                                            <IoLogoWhatsapp color="#24d366" size={30}/>
                                        </a>
                                    </span>
                                </div>

                                {!user_id &&
                                    <span onClick={() => handlePage('shopping', transaction.user_id)} className="pointer fw-bold text-danger print">Todas compras</span>
                                }
                                </>
                            }
                        />
                    </>
                    }

                    <hr className="hr-muted m-0"/>

                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Valor</label>
                    <CardHeader 
                        avatar={
                            <Avatar>
                                <FaDownload />
                            </Avatar>
                        }
                        title={<h5 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(transaction.transaction_amount)}</h5>}
                        subheader={<span className="bs-color">{new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(transaction.updated_at ? transaction.updated_at : transaction.created_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(transaction.updated_at ? transaction.updated_at : transaction.created_at))}</span>}
                    />

                    {(transaction.status === '1' || transaction.status === 'approved' || transaction.status === 'paid') ?
                        <div className="mb-3">
                        {status === 'success' &&
                            <>
                            <hr className="hr-muted m-0"/>
                            <label className="w-100 text-center mt-3 mb-3">
                                <small className="text-success me-2"><FaCheckCircle /></small>
                                <small className="fw-bold bs-color-b">Tudo certo com essa transação</small>
                            </label>
                            </>
                        }
                        {status === 'renotificate' &&
                            <>
                            <hr className="hr-muted m-0"/>
                            <div className="text-center m-2 alert alert-warning mt-3" role="alert">
                                Faltou <strong>{parseInt(transaction.payment_method_id) - count}</strong> cotas desta transação.<br/>
                                Renotifique a transação novamente.
                            </div>

                            </>
                        }
                        </div>
                        :

                        <>
                        {account.gateway === 'paggue' &&
                            <>
                            <hr className="hr-muted m-0"/>
                            <div className="m-2 alert alert-warning mt-3" role="alert">
                                Caso o banco não tenha notificado esse pagamento tente consultar manualmente
                            </div>

                            </>
                        }
                        </>
                    }
                
                    
                    <div className="d-flex card-body justify-content-center">
                        <button className="btn btn-light fw-bold" onClick={() => props.onClose() }>
                            Fechar
                        </button>
                        {(transaction.status !== '1' && transaction.status !== 'approved' && transaction.status !== 'paid') &&
                            <button className="ms-3 btn btn-danger fw-bold" onClick={() => setConfirm(true)}>
                                Consultar
                            </button>
                        }

                        {(status === 'renotificate') &&
                            <button
                                onClick={() => {
                                    dispatch(renotificate(transaction.id))
                                    props.onClose()
                                }}
                                className="ms-3 btn btn-success fw-bold"
                            >
                                Renotificar Transação
                            </button>
                        }

                        {(confirmEl) && 
                            <Confirm
                                open={confirmEl}
                                onConfirm={() => dispatch(consult(transaction.id))}
                                onClose={() => setConfirm(null)}
                                title="O cliente enviou o comprovante de pagamento dessa transação?"
                            />
                        }
                    </div>
                </div>
            }
        </>
    )
}